// The risk/health formulas live in @d-orca/shared/activity-health so the
// server-side alert sweep detects on the exact same math these badges display —
// no drift is possible. This module re-exports them and keeps the pieces that are
// presentation-only: a level's tone, and the phrase a reason code reads as.
import { riskSeverity, type RiskSeverity } from '../../../activity-health/index.js';

export * from '../../../activity-health/index.js';

/** Pick a risk level's tone from a caller-supplied per-severity map — a CSS
 *  class on the web, an ink on the phone. The severity bucketing lives in
 *  shared so every risk indicator agrees. */
export function severityTone<T>(level: number, tones: Readonly<Record<RiskSeverity, T>>): T {
  return tones[riskSeverity(level)];
}

/** Pick a CSS class for a risk level from a caller-supplied per-severity map. The
 *  class names are per-file (each surface owns its CSS module); a severity with
 *  no class reads as none. */
export function severityClassName(
  level: number,
  classes: Record<RiskSeverity, string | undefined>,
): string {
  return severityTone(level, classes) ?? '';
}

/** The i18n key that spells out a risk reason code. */
export const riskReasonKey = (code: string): string => `activities.reason.${code}`;
